<nav aria-label="منوی اصلی">
  <div class="menu">
    <a [routerLink]="['/']">
      <img alt="بازر" fetchpriority=high src="/images/ic_logo.png" width="40" height="56">
    </a>
    <!-- <a [routerLink]="['/store']" routerLinkActive="is-active"> فروشگاه </a> -->
    <a [routerLink]="['/gold-installment-credit']" routerLinkActive="is-active">خرید قسطی</a>
    <a [routerLink]="['/contactus']" routerLinkActive="is-active">تماس با ما</a>
    <a [routerLink]="['/trust']" routerLinkActive="is-active">اعتماد به ما</a>
    <a [routerLink]="['/aboutus']" routerLinkActive="is-active">درباره ما</a>
    <a href="https://baazar.ir/mag/" rel="noopener" target="_blank">مجله بازر</a>
  </div>

  <div class="menu-buttons">
    <a [routerLink]="['/download/']"
       ariaCurrentWhenActive="page"
       routerLinkActive="is-active"
       title="دانلود بازر برای اندروید و آیفون">دانلود اپ
    </a>
    <a href="https://web.baazar.ir/" rel="noopener" target="_blank" title="ورود / ثبت نام">ورود / ثبت نام</a>
  </div>
</nav>
